/**
 * Given some code from a multi-line `` string with extra indenting and empty lines,
 * clean out the excess whitespace from the beginning, end and start of lines.
 *
 * @param {string} code - The code to clean.
 */
export function fixIndent(code) {
    const lines = code.split('\n');
    // Shave off empty lines from the beginning and end.
    while (lines.length > 0 && lines[0].trim().length === 0) {
        lines.shift();
    }
    while (lines.length > 0 && lines[lines.length - 1].trim().length === 0) {
        lines.pop();
    }
    if (lines.length === 0) {
        return;
    }
    // Collect whitespace from first line to strip from all lines.
    const strip = /^(\s*)/.exec(lines[0])[0];
    // Strip matching whitespace.
    return lines.map(line => line.startsWith(strip) ? line.slice(strip.length) : line).join('\n');
}
